const linkSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="20.887px" height="13.529px" viewBox="0 0 20.887 13.529" enable-background="new 0 0 20.887 13.529" xml:space="preserve">
<g id="Layer_1">
	<g>
		<path fill="#FFFFFF" d="M10.064,9.848c2.76,0,4.923-2.164,4.923-4.896C14.988,2.164,12.824,0,10.064,0H4.896
			C2.164,0,0,2.164,0,4.952c0,2.677,2.164,4.841,4.896,4.896V7.818C3.301,7.791,2.029,6.52,2.029,4.952
			c0-1.651,1.271-2.92,2.867-2.92h5.168c1.623,0,2.895,1.269,2.895,2.892s-1.271,2.895-2.895,2.895V9.848z"/>
		<path fill="#FFFFFF" d="M15.963,3.68v2.029c1.623,0,2.895,1.271,2.895,2.895s-1.271,2.895-2.895,2.895h-5.168
			c-1.596,0-2.867-1.271-2.867-2.922c0-1.57,1.271-2.838,2.867-2.867V3.68C8.063,3.732,5.898,5.898,5.898,8.576
			c0,2.79,2.164,4.953,4.896,4.953h5.168c2.76,0,4.924-2.163,4.924-4.953C20.887,5.844,18.723,3.68,15.963,3.68z"/>
	</g>
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids">
</g>
</svg>

`;

export default linkSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/linkSVG.js